/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UsersRouteImport } from './routes/users'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ConfigurationRouteImport } from './routes/configuration'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as AuditTrailRouteImport } from './routes/audit-trail'
import { Route as IndexRouteImport } from './routes/index'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationRoute = ConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditTrailRoute = AuditTrailRouteImport.update({
  id: '/audit-trail',
  path: '/audit-trail',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit-trail': typeof AuditTrailRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/users': typeof UsersRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit-trail': typeof AuditTrailRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/users': typeof UsersRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit-trail': typeof AuditTrailRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/users': typeof UsersRoute
  '/verify-email': typeof VerifyEmailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit-trail'
    | '/chat'
    | '/configuration'
    | '/forgot-password'
    | '/login'
    | '/profile'
    | '/reset-password'
    | '/set-password'
    | '/users'
    | '/verify-email'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit-trail'
    | '/chat'
    | '/configuration'
    | '/forgot-password'
    | '/login'
    | '/profile'
    | '/reset-password'
    | '/set-password'
    | '/users'
    | '/verify-email'
  id:
    | '__root__'
    | '/'
    | '/audit-trail'
    | '/chat'
    | '/configuration'
    | '/forgot-password'
    | '/login'
    | '/profile'
    | '/reset-password'
    | '/set-password'
    | '/users'
    | '/verify-email'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditTrailRoute: typeof AuditTrailRoute
  ChatRoute: typeof ChatRoute
  ConfigurationRoute: typeof ConfigurationRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ProfileRoute: typeof ProfileRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordRoute: typeof SetPasswordRoute
  UsersRoute: typeof UsersRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration': {
      id: '/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof ConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-trail': {
      id: '/audit-trail'
      path: '/audit-trail'
      fullPath: '/audit-trail'
      preLoaderRoute: typeof AuditTrailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditTrailRoute: AuditTrailRoute,
  ChatRoute: ChatRoute,
  ConfigurationRoute: ConfigurationRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ProfileRoute: ProfileRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordRoute: SetPasswordRoute,
  UsersRoute: UsersRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
